module.exports = __webpack_public_path__ + "img/bg.4a6407e5.png";